import { render, staticRenderFns } from "./ProductMessaging.vue?vue&type=template&id=e5052dea&scoped=true&"
import script from "./ProductMessaging.vue?vue&type=script&lang=js&"
export * from "./ProductMessaging.vue?vue&type=script&lang=js&"
import style0 from "./ProductMessaging.vue?vue&type=style&index=0&id=e5052dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../log-in-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5052dea",
  null
  
)

export default component.exports